var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00442C",
    d: "M7.578 12.07c3.108 0 5.403.808 6.636 2.335.923 1.144.944 2.314.944 2.324 0 .234-.2.424-.446.424H.446A.436.436 0 0 1 0 16.73c0-.01.02-1.18.943-2.326 1.23-1.527 3.527-2.334 6.635-2.334zm0-10.164c2.211 0 4.012 1.71 4.012 3.812 0 2.101-1.8 3.811-4.012 3.811-2.211 0-4.012-1.71-4.012-3.811 0-2.102 1.8-3.812 4.012-3.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.7,
    d: "M8.637 10.165c1.893 0 3.514.28 4.82.83 1.07.451 1.93 1.083 2.558 1.88 1.08 1.368 1.092 2.737 1.092 2.796 0 .7-.6 1.27-1.337 1.27H1.504c-.738 0-1.338-.57-1.338-1.27l.001-.041c.009-.245.102-1.5 1.092-2.755.628-.797 1.489-1.43 2.558-1.88 1.306-.55 2.927-.83 4.82-.83zm0 .847c-3.108 0-5.404.807-6.635 2.334-.923 1.145-.943 2.315-.943 2.326 0 .232.2.422.446.422H15.77c.245 0 .446-.19.446-.423 0-.01-.02-1.18-.945-2.325-1.233-1.527-3.527-2.334-6.635-2.334zM8.637 0c2.704 0 4.904 2.09 4.904 4.659s-2.2 4.659-4.904 4.659c-2.704 0-4.904-2.09-4.904-4.66C3.733 2.09 5.933 0 8.637 0zm0 .847c-2.211 0-4.013 1.71-4.013 3.812 0 2.101 1.802 3.812 4.013 3.812s4.012-1.71 4.012-3.812S10.85.847 8.637.847z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3-3h24v24H-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfil);
export default __webpack_public_path__ + "static/media/ic-profil.e3cb5d92efaf4d9429dfa20c51dd333b.svg";
export { ForwardRef as ReactComponent };